import Link from "next/link";
import { cn } from "@rosette/ts/src/util/cn.js";


const NAME_CLASSES = "text-body [text-shadow:-0.075em_-0.075em_0_#000,0.075em_-0.075em_0_#000,-0.075em_0.075em_0_#000,0.075em_0.075em_0_#000]";


interface ByLineProps {
    noLink?: boolean;
}


export function ByLine({ noLink }: ByLineProps) {
    return (
        <span className={cn("block w-full mt-1 md:mt-0 text-[0.55em] font-bold text-right", NAME_CLASSES)}>
            {"by "}

            {!noLink && (
                <Link
                    className={cn("inline-block pb-4 hover:text-accent hover:no-underline", NAME_CLASSES)}
                    href="https://padraiglamont.com">

                    Padraig Lamont
                </Link>
            )}

            {noLink && (
                <div className={cn("inline-block pb-4", NAME_CLASSES)}>
                    Padraig Lamont
                </div>
            )}
        </span>
    );
}
